module.exports = __webpack_public_path__ + "img/bixiu01.034d14da.png";